/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Integration_Use_1_ValueInputs */

const en_svc_integration_use_1_value = /** @type {(inputs: Svc_Integration_Use_1_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invoices and receipts read and entered, with uncertain fields flagged for a person.`)
};

const lv_svc_integration_use_1_value = /** @type {(inputs: Svc_Integration_Use_1_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rēķini un čeki tiek nolasīti un ievadīti, bet neskaidrie lauki atzīmēti cilvēkam.`)
};

/**
* | output |
* | --- |
* | "Invoices and receipts read and entered, with uncertain fields flagged for a person." |
*
* @param {Svc_Integration_Use_1_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_integration_use_1_value = /** @type {((inputs?: Svc_Integration_Use_1_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Integration_Use_1_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_integration_use_1_value(inputs)
	return en_svc_integration_use_1_value(inputs)
});